<template>
 <div id="call-to-action">
   <!-- <p>AVOID patronizing businesses that support Donald Trump.</p> -->
   <h1>AVOID patronizing businesses that support Donald Trump.</h1>
   <p><a class="color-red" href="https://muycompanies.com/">Muy! Brands</a> is a company that, as of June of 2020, owns over 750 franchise locations of popular fast-food restaraunts.</p>
   <p>So far in the 2020 election cycle, the CEO of Muy! Brands, <a class="color-yellow" href="https://en.wikipedia.org/wiki/James_Bodenstedt">James Bodenstedt</a> has donated <a class="color-yellow" href="https://www.opensecrets.org/orgs/summary?topnumcycle=2020&toprecipcycle=All%20cycles&contribcycle=All%20cycles&lobcycle=All%20cycles&outspendcycle=All%20cycles&id=D000070282">$324,852</a> in political donations. These donations have gone to Donald Trump, the Republican National Comittee, and other Republican candidates.</p>
   <p>If these are people you disagree with, vote with your wallet and avoid these franchises. Pressure Pizza Hut, Wendy's, and Taco Bell to take action and prevent their brands from being associated with the likes of Donald Trump.</p>
   <p>Scroll down to see a map of franchises as of May 2020.</p>
   <!-- <p class="disclaimer">
        The factual statements on this site are made based on the public records
        linked herein and the screenshots from web sites linked herein.
    </p>
  <p class="disclaimer">
    We claim no direct knowledge of the donations or corporate structures beyond those sources.
  </p> -->
   <!-- <span class="text-yellow">$$$</span> -->
</div>
</template>

<script>
export default {
}
</script>
